// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__2jIar","detailsBorder":"styles_detailsBorder__1fN43"};